import { createStore } from "zustand/vanilla";
import { errorToMessage } from "../errorToMessage.js";
export const createInviteInboxStore = (deps) => {
    const isEmailVerified = deps.isEmailVerified ?? (() => true);
    const store = createStore((set, get) => {
        // Accept and decline share everything but the repo call: optimistically drop
        // the invite from the list, restore it (with the error) if the call fails.
        const resolve = async (inviteId, call) => {
            const prev = get().invites;
            set({ invites: prev.filter((i) => i.id !== inviteId), error: null });
            const r = await call();
            if (!r.ok)
                set({ invites: prev, error: errorToMessage(r.error) });
            return r;
        };
        return {
            invites: [],
            loading: false,
            error: null,
            async refresh() {
                if (!isEmailVerified()) {
                    set({ invites: [], loading: false, error: null });
                    return;
                }
                set({ loading: true });
                const r = await deps.sharing.listIncomingInvites();
                if (r.ok)
                    set({ invites: r.value, loading: false, error: null });
                else
                    set({ loading: false, error: errorToMessage(r.error) });
            },
            accept: (inviteId) => resolve(inviteId, () => deps.sharing.acceptInvite(inviteId)),
            decline: (inviteId) => resolve(inviteId, () => deps.sharing.declineInvite(inviteId)),
        };
    });
    void store.getState().refresh();
    return store;
};
//# sourceMappingURL=inviteInboxStore.js.map